// project imports
import administration from "./administration";
import runway from "./runway";

// types
import { NavItemType } from "types/menu";

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [runway, administration],
};

export default menuItems;
